// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "@ngx-translate/core";
var PricesService = /** @class */ (function () {
    // serviceTypes: { label: string; value: string; price: number }[] = [
    //   {
    //     label: this.translateService.instant('services.types.new_digital_doc_first_file'),
    //     value: 'new_digital_doc_first_file',
    //     price: 10,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.new_digital_doc_other_file'),
    //     value: 'new_digital_doc_other_file',
    //     price: 3
    //   },
    //   {
    //     label: this.translateService.instant('services.types.new_paper_doc_first_file'),
    //     value: 'new_paper_doc_first_file',
    //     price: 7,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.new_paper_doc_other_file'),
    //     value: 'new_paper_doc_other_file',
    //     price: 2,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.scan_a4'),
    //     value: 'scan_a4',
    //     price: 0.4,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.scan_a3'),
    //     value: 'scan_a3',
    //     price: 0.5,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.scan_a2'),
    //     value: 'scan_a2',
    //     price: 3,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.scan_a1'),
    //     value: 'scan_a1',
    //     price: 5.5,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.scan_a0'),
    //     value: 'scan_a0',
    //     price: 7,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.scan_no_format'),
    //     value: 'scan_no_format',
    //     price: 0,
    //   },
    //   {
    //     label: this.translateService.instant('services.types.box'),
    //     value: 'box',
    //     price: 4
    //   },
    // ];
    /**
     * Class constructor
     */
    function PricesService(apiService, helperService, translateService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.translateService = translateService;
    }
    /**
     * Create a new price
     *
     * @since 1.0.0
     *
     * @param price Price data
     * @returns Observable<any>
     */
    PricesService.prototype.create = function (price) {
        return this.apiService.apiCall('POST', 'prices', price);
    };
    /**
     * Get prices list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PricesService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'prices', params);
    };
    /**
     * Get an exportation file of all prices
     *
     * @since 1.0.0
     */
    PricesService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'prices/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given priceId data from back-end
     *
     * @since 1.0.0
     *
     * @param priceId ID of the price to get
     */
    PricesService.prototype.get = function (priceId) {
        var _this = this;
        return this.apiService.apiCall('GET', "prices/" + priceId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update price with given priceId with given price data
     *
     * @since 1.0.0
     *
     * @param priceId ID of price to update
     * @param data New price's data
     */
    PricesService.prototype.update = function (priceId, data) {
        return this.apiService.apiCall('PUT', "prices/" + priceId, data);
    };
    /**
     * Delete permanently a price
     *
     * @since 1.0.0
     *
     * @param priceId ID of the price
     */
    PricesService.prototype.delete = function (priceId) {
        return this.apiService.apiCall('DELETE', "prices/" + priceId);
    };
    PricesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PricesService_Factory() { return new PricesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.TranslateService)); }, token: PricesService, providedIn: "root" });
    return PricesService;
}());
export { PricesService };
